import axios from "axios";
import emptyItemImage from "../assets/img/empty_item.png";

 //export const baseHost = "http://192.168.0.108:7000/IPos.Delivery";
 //export const baseImageHost = "http://192.168.0.108:7000/IPos.WebImage";

//export const baseHost = "http://178.150.144.247:7000/IPos.Delivery";
//export const baseImageHost = "http://178.150.144.247:7000/IPos.WebImage";

export const baseHost = "https://order.ipos.co.il/iPosWebDeliveryService";
export const baseImageHost = "https://kiosk.ipos.co.il/iPosImageService";

export const host = `${baseHost}/Service`;
export const imageHost = `${baseImageHost}/Images`;
export const documentHost = `${baseHost}/documents`;
export const adVideoHost = `${baseHost}/ADVideo`;

const instance = axios.create({
  baseURL: host,
});

export const getImageUrl = (image, useDefaultEmpty = false) => {
  if (!image && useDefaultEmpty) {
    return emptyItemImage;
  }
  return `${imageHost}/${image}`;
};

export const getImageName = (branchInfo, menuItem) => {    
  if (branchInfo && branchInfo.parent_chain_guid_code && menuItem.office_menu_item_id) {      
    return `${branchInfo.parent_chain_guid_code}_${menuItem.office_menu_item_id}${menuItem.web_image_name_txt?.includes(".") 
      ? `.${menuItem.web_image_name_txt.split(".").pop().toLowerCase()}` : "" }?v=${menuItem.last_update_dt}`;
  }
  return `${menuItem.web_image_name_txt}?v=${menuItem.last_update_dt}`;
}

export const getAdVideoUrl = (branchGuidCode, videoPath) => {
  if (!videoPath || videoPath.trim().length === 0) {
    return "";
  }
  return `${adVideoHost}/${branchGuidCode}/${videoPath}`;
};

export const getGreenBillUrl = (documentCode, useDefaultEmpty = false) => {
  return `${documentHost}/${documentCode}.pdf`;
};

export default instance;
